import { mergeArrayOfUnnormalizedObjects } from "../lib/gql/index";

export const defaultTypePolicies = {
  AcceptTermsMutationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  Account: { keyFields: ["id"] },
  ActivityFeedInterface: { keyFields: ["id"] },
  ActivityReaction: { keyFields: ["id"] },
  ActivityReactionCount: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Age: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  AirdropPromotionalEvent: { keyFields: ["slug"] },
  AlternativeRewardConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Announcement: { keyFields: ["id"] },
  AnnouncementNotification: { keyFields: ["id"] },
  AnonymousUser: { keyFields: ["id"] },
  AnyCardInterface: { keyFields: ["slug"] },
  AnyCardReward: { keyFields: ["id"] },
  AnyCardSubscription: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  AnyCardWithPlayerGameScore: { keyFields: ["id"] },
  AnyContestantInterface: { keyFields: ["id"] },
  AnyConversionCreditReward: { keyFields: ["id"] },
  AnyGameInterface: { keyFields: ["id"] },
  AnyPlayerGameStatsInterface: { keyFields: ["id"] },
  AnyPlayerInterface: { keyFields: ["slug"] },
  AnyPlayerNewsUpdate: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  AnyRewardConfigInterface: { keyFields: ["id"] },
  AnyRewardInterface: { keyFields: ["id"] },
  ApiKey: { keyFields: ["id"] },
  AppearanceBoostShopItem: { keyFields: ["id"] },
  AppearanceInterface: { keyFields: ["id"] },
  AppearanceRule: { keyFields: ["id"] },
  ApplePurchaseToken: { keyFields: ["id"] },
  AuctionNotification: { keyFields: ["id"] },
  AuctionReminder: { keyFields: ["id"] },
  AuthorizationRequest: { keyFields: ["id"] },
  AutoClaimNotification: { keyFields: ["id"] },
  AvailableBalances: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  AverageLastScore: { keyFields: ["id"] },
  AverageLastScoreInterface: { keyFields: ["id"] },
  AverageScoreOpenBoundaries: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  AverageScoresRule: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  BankAccountInterface: { keyFields: ["id"] },
  BankWithdrawal: { keyFields: ["id"] },
  BaseAverageLastScore: { keyFields: ["id"] },
  BaseWithdrawalAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  BaseballAverageStatWithValueType: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  BaseballCard: { keyFields: ["slug"] },
  BaseballContestantType: { keyFields: ["id"] },
  BaseballDivision: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  BaseballPlayer: { keyFields: ["slug"] },
  BaseballPlayerGameScore: { keyFields: ["id"] },
  BaseballTeamGameStats: { keyFields: ["id"] },
  BaseballUserSportProfile: { keyFields: ["id"] },
  BasketballAverageStatWithValueType: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  BasketballContestantType: { keyFields: ["id"] },
  BasketballDivision: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  BasketballPlayerGameScore: { keyFields: ["id"] },
  BasketballTeamGameStats: { keyFields: ["id"] },
  BenchSort: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  BestScoreManagerProfileStat: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  BidSource: { keyFields: ["id"] },
  BidToEarnPromotionalEvent: { keyFields: ["slug"] },
  BidToEarnReward: { keyFields: ["id"] },
  BidToEarnRewardConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Blueprint: { keyFields: ["id"] },
  Board: { keyFields: ["id"] },
  BoardBookmark: { keyFields: ["id"] },
  BoardWithSpecialEditionBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Bookmark: { keyFields: ["id"] },
  BoostLevel: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  BundledPurchasableItem: { keyFields: ["slug"] },
  CaBankAccount: { keyFields: ["id"] },
  Card: { keyFields: ["slug"] },
  CardBoost: { keyFields: ["id"] },
  CardBoostConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardCollection: { keyFields: ["slug"] },
  CardCollectionBonusThreshold: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardCollectionCard: { keyFields: ["id"] },
  CardCollectionCardScoreBreakdown: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardCollectionNotification: { keyFields: ["id"] },
  CardCollectionRequirement: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardCollectionScoreIncrease: { keyFields: ["id"] },
  CardCollectionScoringMatrix: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardCollectionSlot: { keyFields: ["id"] },
  CardCollectionWithProgress: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardCount: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardEditionCount: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardEditionsCount: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardEligibilityRulesInterface: { keyFields: ["id"] },
  CardLayout: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardNotification: { keyFields: ["id"] },
  CardPack: { keyFields: ["slug"] },
  CardPackActivityFeed: { keyFields: ["id"] },
  CardPackGroup: { keyFields: ["slug"] },
  CardPackReward: { keyFields: ["id"] },
  CardPackSection: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardPackSlot: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardPackSlotPlayingStatusOdd: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardPackSlotRankOdd: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardPacksRewardConfig: { keyFields: ["id"] },
  CardPull: { keyFields: ["id"] },
  CardPullCard: { keyFields: ["id"] },
  CardPullConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardPullSource: { keyFields: ["id"] },
  CardRewardConfig: { keyFields: ["id"] },
  CardSample: { keyFields: ["id"] },
  CardSeasonSupply: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardSet: { keyFields: ["slug"] },
  CardSetBranding: { keyFields: ["id"] },
  CardSetBrandingColors: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardSetRoot: { keyFields: ["id"] },
  CardShardRewardConfig: { keyFields: ["id"] },
  CardShardThresholdsPromotionalEvent: { keyFields: ["slug"] },
  CardShardsChest: { keyFields: ["id"] },
  CardShardsChestThreshold: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardShardsChestThresholdDraw: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardShardsChestThresholdDrawsProbability: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardShardsChestThresholdProbability: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardShardsPurchasableItem: { keyFields: ["slug"] },
  CardShardsReward: { keyFields: ["id"] },
  CardSource: { keyFields: ["id"] },
  CardStats: { keyFields: ["id"] },
  CardUsageInterface: { keyFields: ["slug"] },
  CardXPGradeThreshold: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardsCountAsFirstOwnerRule: { keyFields: ["id"] },
  CardsCountTargetTask: { keyFields: ["id"] },
  CardsCountTask: { keyFields: ["id"] },
  CareerBoard: { keyFields: ["id"] },
  CareerProStep: { keyFields: ["id"] },
  CareerStep: { keyFields: ["id"] },
  Cart: { keyFields: ["id"] },
  CartItem: { keyFields: ["id"] },
  CartPurchaseRewardPromotionalEvent: { keyFields: ["slug"] },
  CheckoutCreditCardAuthorizationRequest: { keyFields: ["id"] },
  Club: { keyFields: ["slug"] },
  CoinReward: { keyFields: ["id"] },
  CoinRewardConfig: { keyFields: ["id"] },
  CollectionCompletionManagerProfileStat: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CollectionTaskThreshold: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CommonAccount: { keyFields: ["id"] },
  CommonCardSwapShopItem: { keyFields: ["id"] },
  CommonPlayer: { keyFields: ["id"] },
  CommonPlayerOdds: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Competition: { keyFields: ["slug"] },
  CompetitionCardCollections: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CompetitionCardCollectionsStats: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CompetitionCount: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CompetitionGames: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CompletablePromotionalEventInterface: { keyFields: ["slug"] },
  CompleteCollectionsCountTargetTask: { keyFields: ["id"] },
  CompleteCollectionsCountTask: { keyFields: ["id"] },
  ComposeTeamBenchCard: { keyFields: ["id"] },
  ComposeTeamBenchCommonPlayer: { keyFields: ["id"] },
  ComposeTeamBenchObjectInterface: { keyFields: ["id"] },
  ComposeTeamLineupPreview: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Config: { keyFields: ["id"] },
  ConfirmDeviceMutationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  ConfirmEmailMutationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  ConnectedOAuth: { keyFields: ["id"] },
  ConsumeEphemeralTokenMutationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  Contestant: { keyFields: ["id"] },
  Contract: { keyFields: ["id"] },
  ConversionCredit: { keyFields: ["id"] },
  ConversionCreditCampaign: { keyFields: ["id"] },
  ConversionCreditNotification: { keyFields: ["id"] },
  ConversionCreditRewardConfig: { keyFields: ["id"] },
  CountByRarity: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Country: { keyFields: ["slug"] },
  Counts: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CreateMutationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  CreateOrUpdateSo5LineupMutationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  CreditCard: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CurrentUser: { keyFields: ["slug"] },
  CurrentUserTaskWasUpdatedPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  DailyActionTask: { keyFields: ["id"] },
  DataPartner: { keyFields: ["slug"] },
  DateRangeSpecific: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  DecisiveActionNotification: { keyFields: ["id"] },
  DecisiveEventInterface: { keyFields: ["id"] },
  DecisivePlayerPickerTask: { keyFields: ["id"] },
  DecisivePlayerPickerTaskAppearance: { keyFields: ["id"] },
  DecisivePurchaseNotification: { keyFields: ["id"] },
  Deck: { keyFields: ["slug"] },
  DeliverableItemInterface: { keyFields: ["slug"] },
  DeliverableItemOrder: { keyFields: ["id"] },
  DeliverableItemReward: { keyFields: ["id"] },
  DeliverableItemRewardConfig: { keyFields: ["id"] },
  DeliverableItemVariantsStocks: { keyFields: ["id"] },
  DeliverableItemsRewardsOverview: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  DeliverableWithCustomVariantShopItem: { keyFields: ["id"] },
  DeliverableWithNoVariantShopItem: { keyFields: ["id"] },
  DepositPromotionalEvent: { keyFields: ["slug"] },
  DivisionChangeConfiguration: { keyFields: ["id"] },
  DropChallengeTask: { keyFields: ["id"] },
  Eip7702Revocation: { keyFields: ["id"] },
  EligibilityRules: { keyFields: ["id"] },
  EligibleCollectionRule: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  EmailSubscription: { keyFields: ["slug"] },
  EmailSubscriptionPreferences: { keyFields: ["slug"] },
  EngineConfiguration: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  EnglishAuctionSource: { keyFields: ["id"] },
  EthBankWithdrawalIntent: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  EthDeposit: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  EthMigration: { keyFields: ["id"] },
  EthereumAccount: { keyFields: ["id"] },
  EthereumBankConditionalTransferAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  EthereumBankTransferAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  EthereumTransaction: { keyFields: ["id"] },
  Event: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ExchangeRate: { keyFields: ["id"] },
  ExperienceDeliverableItem: { keyFields: ["slug"] },
  ExperienceReward: { keyFields: ["id"] },
  ExperienceRewardConfig: { keyFields: ["id"] },
  ExternalDepositNotification: { keyFields: ["id"] },
  ExtraSwapShopItem: { keyFields: ["id"] },
  FaceLandmark: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  FastWithdrawal: { keyFields: ["id"] },
  FastWithdrawalWithRates: { keyFields: ["id"] },
  FeaturedCardPack: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  FeaturedLeagues: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  FeaturedMarketSection: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  FeaturedMarketSectionItem: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  FeaturedMarketSectionValueProp: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  FeaturedSo5LeaderboardContenders: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  FeaturedSo5LeaderboardGroups: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Fee: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Fiat: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  FiatWalletAccount: { keyFields: ["id"] },
  FixturePlayer: { keyFields: ["id"] },
  FlashSalePicks: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  FootballAverageStatWithValueType: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  FootballContestantType: { keyFields: ["id"] },
  FootballConversionCredit: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  FootballGoalEvent: { keyFields: ["id"] },
  FootballRewardShopItem: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  FootballRoot: { keyFields: ["id"] },
  FootballSanctionCardEvent: { keyFields: ["id"] },
  FootballSo5NoCardRouteRoot: { keyFields: ["id"] },
  FootballTeamGameStats: { keyFields: ["id"] },
  FootballUserSportProfile: { keyFields: ["id"] },
  ForYouRoot: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  FullWithdrawalRequest: { keyFields: ["id"] },
  GalleryCards: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Game: { keyFields: ["id"] },
  GameDay: { keyFields: ["id"] },
  GameOfBaseball: { keyFields: ["id"] },
  GameOfBasketball: { keyFields: ["id"] },
  GameWeeklyTask: { keyFields: ["id"] },
  GameWeeklyTaskInterface: { keyFields: ["id"] },
  GameWithCardsPreview: { keyFields: ["id"] },
  GameWithPlayerGameScoresPreview: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  GameplayTierOdds: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  GameplayTierRating: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  GbBankAccount: { keyFields: ["id"] },
  GemsShop: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  GenericSpotlight: { keyFields: ["id"] },
  GuessTheScoreTask: { keyFields: ["id"] },
  GuessTheScoreTaskLineup: { keyFields: ["id"] },
  HeroValueProp: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  HighScarcity: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  HighScarcityStatuses: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  HighlightedStat: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  HistoryTransactionInterface: { keyFields: ["id"] },
  IbanBankAccount: { keyFields: ["id"] },
  ImportedSo5Appearance: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  InGameCurrencyBalance: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  InGameCurrencyNotification: { keyFields: ["id"] },
  InGameCurrencyPack: { keyFields: ["id"] },
  InGameCurrencyPurchasableItem: { keyFields: ["slug"] },
  InGameCurrencyReward: { keyFields: ["id"] },
  InGameCurrencyRewardConfig: { keyFields: ["id"] },
  InGameCurrencySource: { keyFields: ["id"] },
  InGameCurrencyTransaction: { keyFields: ["id"] },
  IncompleteCardCollection: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Injury: { keyFields: ["id"] },
  Inning: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  InstantBuyCampaign: { keyFields: ["id"] },
  IntegerBySportType: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  InviteTaskAsReferrer: { keyFields: ["id"] },
  JerseyDeliverableItem: { keyFields: ["slug"] },
  JerseyShopItem: { keyFields: ["id"] },
  JonumBlockingStatus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  JonumRestrictions: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  JonumVerificationNotification: { keyFields: ["id"] },
  JwtToken: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  KlarnaPayinConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  KycDocumentRequirement: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  KycRequestNotification: { keyFields: ["id"] },
  LadderContribution: { keyFields: ["id"] },
  LadderLeaderboard: { keyFields: ["slug"] },
  LadderRanking: { keyFields: ["id"] },
  LadderRewardBracket: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  LeaderboardRewardsConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  LegacyPacks: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  LevelUpShopItem: { keyFields: ["id"] },
  LeveledUpCard: { keyFields: ["id"] },
  LineupActivityFeed: { keyFields: ["id"] },
  LineupInterface: { keyFields: ["id"] },
  ListedOnMarket: { keyFields: ["slug"] },
  Loan: { keyFields: ["id"] },
  LoanNotification: { keyFields: ["id"] },
  LoanableConfigRoot: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  LoanableRoster: { keyFields: ["id"] },
  LoanedToken: { keyFields: ["id"] },
  LobbySection: { keyFields: ["slug"] },
  Location: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  LoomAccount: { keyFields: ["id"] },
  ManagerProfileStat: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ManagerTaskInterface: { keyFields: ["id"] },
  ManagerTeam: { keyFields: ["id"] },
  MangopayApplePayAuthorizationRequest: { keyFields: ["id"] },
  MangopayBankAccountOwnerAddress: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  MangopayCreditCardAuthorizationRequest: { keyFields: ["id"] },
  MangopayIdentityVerification: { keyFields: ["id"] },
  MangopayInternalTransfer: { keyFields: ["id"] },
  MangopayKlarnaAuthorizationRequest: { keyFields: ["id"] },
  MangopayKycDocument: { keyFields: ["id"] },
  MangopayKycRequest: { keyFields: ["id"] },
  MangopayRemotePreAuthorizationStatus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  MangopayRemoteTransactionStatus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  MangopayRoot: { keyFields: ["id"] },
  MangopayUser: { keyFields: ["id"] },
  MangopayWalletTransferAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  MangopayWithdrawal: { keyFields: ["id"] },
  MarketItem: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  MarketLiveOps: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  MarketPromotionalEvent: { keyFields: ["slug"] },
  MarketRoot: { keyFields: ["id"] },
  MarketSetSection: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  MarketSetSpecialBundles: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  MarketSetWelcomeOffer: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  MarketingNotification: { keyFields: ["id"] },
  MarketplacePreference: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  MarketplaceSportPreferences: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  MaximumCardsCountOwnedByUser: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Membership: { keyFields: ["id"] },
  MissedAppearance: { keyFields: ["id"] },
  MissedLineup: { keyFields: ["slug"] },
  MonetaryAmount: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  MonetaryReward: { keyFields: ["id"] },
  MonetaryRewardConfig: { keyFields: ["id"] },
  Mutation: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  NBACard: { keyFields: ["slug"] },
  NBAPlayer: { keyFields: ["slug"] },
  NBAUserSportProfile: { keyFields: ["id"] },
  NationalTeam: { keyFields: ["slug"] },
  Nationality: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  NoCardRoute: { keyFields: ["id"] },
  Node: { keyFields: ["id"] },
  NotificationInterface: { keyFields: ["id"] },
  NotificationPreference: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  NotificationSection: { keyFields: ["slug"] },
  NotificationSubsection: { keyFields: ["slug"] },
  OAuthAccessToken: { keyFields: ["id"] },
  OAuthApplication: { keyFields: ["id"] },
  OffRampAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  OffRampBridgeAccount: { keyFields: ["id"] },
  OffRampKycNotification: { keyFields: ["id"] },
  OffRampQuote: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  OffRampWithdrawal: { keyFields: ["id"] },
  OfferNotification: { keyFields: ["id"] },
  OnboardingLeaderboard: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  OrderedPlayerGameScores: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  OrderedSo5Scores: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  OtherBankAccount: { keyFields: ["id"] },
  OverperformAverageScoreConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  OwnedSinceRule: { keyFields: ["id"] },
  Owner: { keyFields: ["id"] },
  OwnerInterface: { keyFields: ["id"] },
  OwnerWithRates: { keyFields: ["id"] },
  Pack: { keyFields: ["id"] },
  PackConfigPurchasableItem: { keyFields: ["slug"] },
  PackPlayerOdds: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PackSource: { keyFields: ["id"] },
  PageInfo: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Passkey: { keyFields: ["id"] },
  PasskeyChallenge: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PasswordEncryptedPrivateKey: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Payment: { keyFields: ["id"] },
  PaymentDepositStatus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PaymentMethod: { keyFields: ["id"] },
  PaymentMethodFeeRate: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PaymentRoot: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PaypalAuthorizationRequest: { keyFields: ["id"] },
  PendingDeposit: { keyFields: ["id"] },
  PendingPlaytimeLimit: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PendingSpendingLimit: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PeriodScore: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PickableCard: { keyFields: ["slug"] },
  PickablePlayer: { keyFields: ["slug"] },
  PickableTeam: { keyFields: ["slug"] },
  PictureFrameShopItem: { keyFields: ["id"] },
  Player: { keyFields: ["slug"] },
  PlayerGameScore: { keyFields: ["id"] },
  PlayerGameScoreInterface: { keyFields: ["id"] },
  PlayerGameScoreProjection: { keyFields: ["id"] },
  PlayerGameStats: { keyFields: ["id"] },
  PlayerGameStatsBaseball: { keyFields: ["id"] },
  PlayerGameStatsBasketball: { keyFields: ["id"] },
  PlayerHeightRule: { keyFields: ["id"] },
  PlayerRecommendation: { keyFields: ["id"] },
  PlayerWithSupply: { keyFields: ["slug"] },
  PlayingStatusOdds: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PlaytimeUsage: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PoolKeyShardsCount: { keyFields: ["slug"] },
  PostalAddress: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PotentialDiscountBreakdown: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PowerBreakdown: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PowerPointsBreakdown: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PreRegistrationData: { keyFields: ["id"] },
  PrimaryOfferSource: { keyFields: ["id"] },
  PrintablePlayerSource: { keyFields: ["id"] },
  PrivateAccount: { keyFields: ["id"] },
  PrivateEmptyAccount: { keyFields: ["id"] },
  PrivateFiatWalletAccount: { keyFields: ["id"] },
  PrivateKeyRecoveryOption: { keyFields: ["id"] },
  PrivateKeyRecoveryPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ProbabilisticBundle: { keyFields: ["id"] },
  ProbabilisticBundleConfig: { keyFields: ["id"] },
  ProbabilisticBundleConfigSlot: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ProbabilisticBundleOpeningDisclaimer: { keyFields: ["slug"] },
  ProbabilisticBundleReward: { keyFields: ["id"] },
  ProbabilisticBundleRewardConfig: { keyFields: ["id"] },
  ProbabilisticBundleSlotArenaTicketItem: { keyFields: ["id"] },
  ProbabilisticBundleSlotCardItem: { keyFields: ["id"] },
  ProbabilisticBundleSlotCardShardItem: { keyFields: ["id"] },
  ProbabilisticBundleSlotConfig: { keyFields: ["id"] },
  ProbabilisticBundleSlotConversionCreditItem: { keyFields: ["id"] },
  ProbabilisticBundleSlotDeliverableItem: { keyFields: ["id"] },
  ProbabilisticBundleSlotInGameCurrencyItem: { keyFields: ["id"] },
  ProbabilisticBundleSlotItemInterface: { keyFields: ["id"] },
  ProbabilisticBundleSlotPackItem: { keyFields: ["id"] },
  ProbabilisticBundleSlotRewardShopItem: { keyFields: ["id"] },
  ProbabilisticBundleSource: { keyFields: ["id"] },
  ProbabilisticBundlesRewardsOverview: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ProbablePitchersForGameWeek: { keyFields: ["slug"] },
  ProbableRewardConfig: { keyFields: ["id"] },
  ProgressionForRewardConfigThresholds: { keyFields: ["id"] },
  PromotionalEventCompletion: { keyFields: ["id"] },
  PromotionalEventInterface: { keyFields: ["slug"] },
  PublicUserInfoInterface: { keyFields: ["slug"] },
  PurchasableItemInterface: { keyFields: ["slug"] },
  PurchasableItemsVoucher: { keyFields: ["id"] },
  Query: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Raffle: { keyFields: ["slug"] },
  RaffleShopItem: { keyFields: ["id"] },
  Range: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  RarityCount: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  RarityRewardConfigs: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Rates: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Referral: { keyFields: ["id"] },
  ReferralPaginated: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ReferralProgramConfig: { keyFields: ["id"] },
  ReferralReward: { keyFields: ["id"] },
  ReferralRewardNotification: { keyFields: ["id"] },
  RejectedCraftSource: { keyFields: ["id"] },
  ReminderNotification: { keyFields: ["id"] },
  RevealCost: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  RevealableCardCampaign: { keyFields: ["slug"] },
  RevealableCardConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  RevealedCardsSummary: { keyFields: ["id"] },
  RevealedEditionsConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  RewardBoost: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  RewardCard: { keyFields: ["id"] },
  RewardConfigThreshold: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  RewardDeliverableItem: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  RewardMultiplierConfiguration: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  RewardPoolShare: { keyFields: ["id"] },
  RewardUsage: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  RewardsOverview: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  RoomsConfig: { keyFields: ["slug"] },
  SaleNotification: { keyFields: ["id"] },
  ScoringMatrix: { keyFields: ["id"] },
  ScreenshottableCard: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SealingConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SearchCardHit: { keyFields: ["slug"] },
  SearchCardHits: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SearchCardSale: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SearchCards: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SearchFacet: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SearchFacetValue: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SearchGroup: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SearchGroupKey: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SearchGroupedCards: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SearchPlayers: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SearchProcessingTime: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Season: { keyFields: ["id"] },
  SeasonBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SeasonCount: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SeasonPicture: { keyFields: ["id"] },
  SeasonsRule: { keyFields: ["id"] },
  ShopItem: { keyFields: ["id"] },
  ShopItemInterface: { keyFields: ["id"] },
  ShopItemReward: { keyFields: ["id"] },
  ShopItemRewardConfig: { keyFields: ["id"] },
  SignInMutationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  SignInWithOAuthMutationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  SignUpMutationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  SignedCardPrice: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SkinEdition: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SkinShopItem: { keyFields: ["id"] },
  SkinTierOdds: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5ActiveClubsBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5ActiveClubsRule: { keyFields: ["id"] },
  So5ActiveNationalTeamsRule: { keyFields: ["id"] },
  So5AgeRule: { keyFields: ["id"] },
  So5Appearance: { keyFields: ["id"] },
  So5AppearanceInterface: { keyFields: ["id"] },
  So5AppearancePreview: { keyFields: ["id"] },
  So5AppearancesRule: { keyFields: ["id"] },
  So5AtLeastOfClubs: { keyFields: ["id"] },
  So5AtLeastOfCompetitions: { keyFields: ["id"] },
  So5AverageScoresBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5AverageScoresRule: { keyFields: ["id"] },
  So5BoostBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5CaptainBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5CaptainRule: { keyFields: ["id"] },
  So5CaptainScarcityRule: { keyFields: ["id"] },
  So5CardEditionsCountRule: { keyFields: ["id"] },
  So5CardRewardBoost: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5CardShardsEntryItem: { keyFields: ["id"] },
  So5CollectionBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5Competition: { keyFields: ["slug"] },
  So5CompetitionSpotlight: { keyFields: ["id"] },
  So5CompetitionsRule: { keyFields: ["id"] },
  So5Config: { keyFields: ["id"] },
  So5DeliverableItemReward: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5DifferentNationalitiesBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5EntryItemInterface: { keyFields: ["id"] },
  So5EntryItemRule: { keyFields: ["id"] },
  So5Fixture: { keyFields: ["slug"] },
  So5FixturePreparing: { keyFields: ["slug"] },
  So5FixturePublicInterface: { keyFields: ["slug"] },
  So5GradeBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5Leaderboard: { keyFields: ["slug"] },
  So5LeaderboardBookmark: { keyFields: ["id"] },
  So5LeaderboardContender: { keyFields: ["slug"] },
  So5LeaderboardEntryItemSource: { keyFields: ["id"] },
  So5LeaderboardFormat: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5LeaderboardGroup: { keyFields: ["slug"] },
  So5LeaderboardGroupInterface: { keyFields: ["slug"] },
  So5LeaderboardTask: { keyFields: ["id"] },
  So5LeaderboardTaskInterface: { keyFields: ["id"] },
  So5League: { keyFields: ["slug"] },
  So5LeagueTrack: { keyFields: ["slug"] },
  So5LeagueTrackGroup: { keyFields: ["slug"] },
  So5Lineup: { keyFields: ["id"] },
  So5LineupBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5LineupImport: { keyFields: ["id"] },
  So5LineupImportsBatch: { keyFields: ["id"] },
  So5LineupNotification: { keyFields: ["id"] },
  So5LineupPreview: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5LineupSimulatedResult: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5LineupSimulatedResults: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5MalusAfterTransferBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5MaximumPlayersAverageScoreRule: { keyFields: ["id"] },
  So5MinimumPlayersAverageScoreRule: { keyFields: ["id"] },
  So5NationalityBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5NationalityRule: { keyFields: ["id"] },
  So5NoCardAppearance: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5NoCardDraftableAppearance: { keyFields: ["id"] },
  So5NoCardLineup: { keyFields: ["id"] },
  So5NoCardRouteFixturePickConfig: { keyFields: ["id"] },
  So5NoCardRoutePickingSlot: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5NotNationalityRule: { keyFields: ["id"] },
  So5OnboardingPromotionalEvent: { keyFields: ["id"] },
  So5PlayerBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5PlayerLoyaltyRewardBoost: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5Podium: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5PositionBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5PositionStacksBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5PotentialRewardConfigs: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5Ranking: { keyFields: ["id"] },
  So5RankingsPaginated: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5Rarity: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5RarityVaultRewardBoost: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5Reward: { keyFields: ["slug"] },
  So5RewardCardConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5RewardConfig: { keyFields: ["id"] },
  So5RewardConfigLock: { keyFields: ["slug"] },
  So5RewardConfigWithEligibility: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5RewardExperience: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5RewardSource: { keyFields: ["id"] },
  So5RewardTargetConfig: { keyFields: ["slug"] },
  So5Root: { keyFields: ["id"] },
  So5RuleDescription: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5RuleDescriptionItem: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5RuleFeedback: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5RuleInterface: { keyFields: ["id"] },
  So5Rules: { keyFields: ["id"] },
  So5SameActiveClubBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5SameActiveClubRule: { keyFields: ["id"] },
  So5ScarcityBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5ScarcityRule: { keyFields: ["id"] },
  So5Score: { keyFields: ["id"] },
  So5SeasonBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5SeasonBonusRule: { keyFields: ["id"] },
  So5SpecialEdition: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5SpecialEditionCardsBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5Tournament: { keyFields: ["id"] },
  So5Trophies: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5UserGroup: { keyFields: ["slug"] },
  So5UserGroupMembership: { keyFields: ["id"] },
  So5UserGroupMembershipsPaginated: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5UserGroupNotification: { keyFields: ["id"] },
  So5UserGroupTournament: { keyFields: ["id"] },
  SocialPictureDerivative: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SolanaAccount: { keyFields: ["id"] },
  SolanaBankConditionalTransferAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SolanaBankTransferAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SolanaBankWithdrawalAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SolanaRentFunding: { keyFields: ["id"] },
  SolanaTokenTransferAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SorarePrivateKey: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SorareRefund: { keyFields: ["id"] },
  SortingType: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SpecialEditionPromotionalEvent: { keyFields: ["slug"] },
  SpecialOffers: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SpecialWeeklyBanner: { keyFields: ["slug"] },
  SpendingUsage: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SportSeason: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SportStat: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Spotlight: { keyFields: ["id"] },
  SpotlightStatTile: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Squad: { keyFields: ["id"] },
  SquadBoard: { keyFields: ["id"] },
  SquadLeaderboardLineup: { keyFields: ["id"] },
  SquadStep: { keyFields: ["id"] },
  StageGroup: { keyFields: ["id"] },
  StarPackTask: { keyFields: ["id"] },
  StarkexLimitOrderAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  StarkexTransferAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  StarkexV6TokenTransferAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  StarkwareAccount: { keyFields: ["id"] },
  StarkwareEscapeHatch: { keyFields: ["id"] },
  StarkwarePrivateAccount: { keyFields: ["id"] },
  StarkwareWithdrawal: { keyFields: ["id"] },
  Stat: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  StatCustomScoring: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  StatScore: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Stats: { keyFields: ["id"] },
  StepInterface: { keyFields: ["id"] },
  StepWonCount: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Story: { keyFields: ["id"] },
  StripeCreditCardAuthorizationRequest: { keyFields: ["id"] },
  Subscription: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SubstitutionEvent: { keyFields: ["id"] },
  Suspension: { keyFields: ["id"] },
  Task: { keyFields: ["id"] },
  TaskAppearance: { keyFields: ["id"] },
  TaskAppearanceInterface: { keyFields: ["id"] },
  TaskCampaign: { keyFields: ["slug"] },
  TaskCampaignDetailSection: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TaskCampaignStep: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TaskCampaignsHomepage: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TaskCampaignsHomepageCampaign: { keyFields: ["slug"] },
  TaskCampaignsHomepageTutorial: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TaskCampaignsHomepageTutorialSection: { keyFields: ["slug"] },
  TaskConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TaskGroup: { keyFields: ["slug"] },
  TaskInterface: { keyFields: ["id"] },
  TaskLineup: { keyFields: ["id"] },
  TaskLineupInterface: { keyFields: ["id"] },
  TaskNotification: { keyFields: ["id"] },
  TaskPreparedLineup: { keyFields: ["id"] },
  TaskSource: { keyFields: ["id"] },
  TaskStatThreshold: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TasksTrack: { keyFields: ["id"] },
  TeamFormation: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TeamGameStatsInterface: { keyFields: ["id"] },
  TeamInterface: { keyFields: ["slug"] },
  TeamVariantStock: { keyFields: ["id"] },
  TeamsPlayingNextGameWeek: { keyFields: ["slug"] },
  ThreeDimensionalAsset: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ThreeDimensionalCardLayout: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ThresholdPickerTask: { keyFields: ["id"] },
  ThresholdPickerTaskAppearance: { keyFields: ["id"] },
  ThresholdPickerTaskLineup: { keyFields: ["id"] },
  ThresholdStreakTaskCurrentThresholdStatus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ThresholdStreakTaskThreshold: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ThresholdsDuoConnectionTask: { keyFields: ["id"] },
  ThresholdsStreakAdditionalLineupTask: { keyFields: ["id"] },
  ThresholdsStreakTask: { keyFields: ["id"] },
  TicketsDeliverableItem: { keyFields: ["slug"] },
  TitleBodyNotificationMobileRendering: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TitleBodyNotificationRendering: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TokenAuction: { keyFields: ["id"] },
  TokenBid: { keyFields: ["id"] },
  TokenDeposit: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TokenMonetaryReward: { keyFields: ["id"] },
  TokenMyBid: { keyFields: ["id"] },
  TokenOffer: { keyFields: ["id"] },
  TokenOfferSide: { keyFields: ["id"] },
  TokenOperationTradeInterface: { keyFields: ["id"] },
  TokenOwner: { keyFields: ["id"] },
  TokenPrice: { keyFields: ["id"] },
  TokenPrimaryOffer: { keyFields: ["id"] },
  TokenRoot: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TokenWithdrawal: { keyFields: ["id"] },
  TournamentCalendarStage: { keyFields: ["id"] },
  TournamentEligibility: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TradedPlayer: { keyFields: ["id"] },
  TrophiesSummary: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  UnblockEmailPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  UnknownSource: { keyFields: ["id"] },
  UpdateMutationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  UsBankAccount: { keyFields: ["id"] },
  UsedInSo5Lineups: { keyFields: ["slug"] },
  UsedInTaskLineups: { keyFields: ["slug"] },
  UsedInTaskPreparedLineups: { keyFields: ["slug"] },
  UsedInTasks: { keyFields: ["slug"] },
  User: { keyFields: ["slug"] },
  UserAccountEntry: { keyFields: ["id"] },
  UserCardCollection: { keyFields: ["id"] },
  UserCardCollectionSlot: { keyFields: ["slug"] },
  UserCardsCount: { keyFields: ["slug"] },
  UserDevice: { keyFields: ["id"] },
  UserDeviceEvent: { keyFields: ["id"] },
  UserError: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  UserFixtureResults: { keyFields: ["slug"] },
  UserFlag: { keyFields: ["id"] },
  UserGroupInterface: { keyFields: ["slug"] },
  UserGroupMembershipInterface: { keyFields: ["id"] },
  UserGroupMembershipShopItemsUpdate: { keyFields: ["id"] },
  UserOwner: { keyFields: ["id"] },
  UserProfile: { keyFields: ["id"] },
  UserProfileBadge: { keyFields: ["slug"] },
  UserRankingInterface: { keyFields: ["id"] },
  UserRelation: { keyFields: ["id"] },
  UserRelationNotification: { keyFields: ["id"] },
  UserSettings: { keyFields: ["id"] },
  UserShopItem: { keyFields: ["id"] },
  UserSource: { keyFields: ["id"] },
  UserSportProfileInterface: { keyFields: ["id"] },
  UserSportStatistic: { keyFields: ["id"] },
  UserWallet: { keyFields: ["id"] },
  UserWithSubscriptionSlug: { keyFields: ["slug"] },
  UsersFixtureResultsPreview: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Validity: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ValueBoundaries: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ValueOpenBoundaries: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  VariantStockCount: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  VaultPointsRule: { keyFields: ["id"] },
  Venue: { keyFields: ["id"] },
  Verification: { keyFields: ["id"] },
  VerificationSession: { keyFields: ["id"] },
  Watchlist: { keyFields: ["slug"] },
  WearableDeliverableItem: { keyFields: ["slug"] },
  WeeklyDeals: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  WheelConfig: { keyFields: ["slug"] },
  WheelCost: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  WheelTicketEligibilityRules: { keyFields: ["id"] },
  WinningLineup: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  WithNotifications: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  WithSubscriptionsInterface: { keyFields: ["slug"] },
  Withdrawal: { keyFields: ["id"] },
  WithdrawalWithRates: { keyFields: ["id"] },
  XPCooldownPromotionalEvent: { keyFields: ["slug"] },
  acceptOfferPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  acceptSo5NoCardBoardDraftableAppearancePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  acceptSo5NoCardDraftableAppearancePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  acceptSo5NoCardLineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  acknowledgeStepPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  activateWalletRecoveryPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  addAuctionReminderPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  addDevicePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  addReferrerCodePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  addSolanaAddressPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  addToCartPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  addToWatchlistPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  addTokensToDeckPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  addWalletRecoveryPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  approveMigratorPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  askForProxyConsentPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  bidPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  blockUserOffersPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  buyCardPackPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  cancelBankWithdrawalPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  cancelMobilePurchasePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  cancelOfferPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  changePasswordPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  checkPhoneNumberVerificationCodePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  claimAllSetRaffleTasksPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  claimAnyRewardPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  claimCardsFromPackPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  claimConversionCreditPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  claimDeliverableItemOrderPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  claimOnboardingConversionCreditPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  claimOnboardingEnergyGiftPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  claimPromotionalEventAirdropPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  claimReferralRewardPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  claimRewardPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  claimRewardsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  claimStarterPackPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  claimStepPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  claimTaskPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  collectJonumPersonalInfoPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  completeDropChallengePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  confirmCardPullPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  confirmDeviceWithCodePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  confirmSo5LineupImportsBatchPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  confirmSo5LineupsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  confirmSo5NoCardLineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  convertCraftCluesPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createApiKeyPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createBankWithdrawalPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createBookmarkPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createCardAuthorizationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createCardRegistrationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createConnectedTasksPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createCryptoDepositPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createDeckPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createDepositBankAccountMutationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createDirectOfferPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createEphemeralLinkPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createEthBankWithdrawalIntentPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createEthDepositPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createEthVaultPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createFiatPayerPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createFiatWalletPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createFiatWithdrawalPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createIdentityVerificationSessionPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createJonumVerificationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createJwtTokenPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createOffRampBridgeCustomerPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createOffRampBridgeTosLinkPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createOnboardingSo5LineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createOrUpdateSingleBuyOfferMinPricePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createPasskeyPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createSingleSaleOfferPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createSo5LineupImportsBatchPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createSo5NoCardBoardLineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createSo5UserGroupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createSquadPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createStarkwareEscapeHatchPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createSubscriptionPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createTaskPreparedLineupFromTaskLineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createWalletPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createWireTransferDepositPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createWithdrawalBankAccountPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  deactivateWalletRecoveryPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  declineSo5LineupImportsBatchPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  declineSo5NoCardLineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  deleteApiKeyPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  deleteBookmarkPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  deleteConnectedTaskPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  deleteDeckPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  deleteOAuthApplicationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  deletePasskeyPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  deletePostalAddressPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  deleteSo5LineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  deleteSo5UserGroupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  deleteSubscriptionPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  deleteTaskLineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  deleteWithdrawalBankAccountPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  depositWithApplePayPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  destroyAccountPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  destroyReferralPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  destroyTaskPreparedLineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  destroyWatchlistPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  detachPaymentMethodPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  disable2faPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  disconnectOmniauthProviderPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  dropAndAddCardsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  editDeckPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  enable2faPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  enrollSCAPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  fetchEncryptedPrivateKeyPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  generateAccountingExtractPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  generateOtpBackupCodesPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  generateOtpProvisioningUriPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  generatePasskeyChallengeForCreatePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  generatePasskeyChallengeForSignInPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  generateReferrerCodePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  generateSo5NoCardLineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  hideMyFeaturedSo5LeaderboardGroupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  joinSo5UserGroupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  joinSquadPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  leaveSquadPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  levelUpCardWithXpCurrencyPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  levelUpCardsWithXpCurrencyPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  linkEthereumAddressPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  loadPreviousLineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  loadSuggestedLineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  lockProModePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  markAsProOnboardedPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  markCardShardsChestUnlockedThresholdAsSeenPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  markNotificationsAsReadPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  markSocialFeedAsReadPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  markSpotlightAsSeenPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  markStoriesAsReadPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  migrateEthPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  offRampPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  pickPulledCardPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  prepareAcceptOfferPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  prepareAcceptTradeWithWalletAndCreditCardPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  prepareBankWithdrawalPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  prepareBidPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  prepareBuyInGameCurrencyPackWithCreditCardPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  prepareDepositPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  prepareEthDepositPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  prepareIdealDepositPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  prepareMigrateEthPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  prepareOffRampPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  prepareOfferPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  preparePayByBankDepositPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  preparePaypalDepositPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  prepareSorareRefundPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  prepareTokenDepositPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  probabilisticBundlesOpenPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  pullCardsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  reactToActivityPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  refreshCartPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  refundSorarePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  rejectCardPullPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  rejectOfferPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  removeActivityPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  removeAuctionReminderPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  removeFromCartPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  removeFromWatchlistPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  removeMemberFromSquadPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  removeTokenFromDeckPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  removeUserFromSo5UserGroupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  reorderTaskPreparedLineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  reportTelemetryPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  reportUserPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  requestJonumSelfExclusionPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  requestSo5NoCardBoardDraftableAppearancePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  requestSo5NoCardDraftableAppearancePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  requestSo5NoCardLineupEligibleLeaderboardsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  resendConfirmationInstructionsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  resendVerificationCodePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  resetPrivateKeyPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  resetSo5NoCardBoardDraftedAppearancesPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  resetSo5NoCardDraftedAppearancesPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  restartTasksTrackPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  restoreWalletPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  revealBlueprintsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  revealPropertyPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  revokeDevicePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  revokeEip7702DelegationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  revokeOAuthAccessTokenForApplicationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  revokeOAuthAccessTokenPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  saveForLaterPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  sealCardsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  sendWalletRecoveryPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  setDeviceTokenPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  setJonumPlaytimeLimitPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  setJonumSpendingLimitPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  setTokenTradeStatusPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  shareCardPackPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  shareLineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  signOutFromAllDevicesPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  skipOnboardingPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  spinWheelPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  startFiatWalletIdentityVerificationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  startOffRampBridgeKycPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  stopAutoBidPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  storeApplePurchaseTokenPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  suggestLineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  swapTaskAppearancesPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  unblockFiatWalletPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  unblockUserOffersPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  unlockNextBoardPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  unlockProModePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  unsealCardsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  unsubscribeFromEmailsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateCardFiltersPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateExternalEthDepositPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateFavoriteTeamPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateFiatWalletPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateHighlightedCardPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateManagerTeamPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateOnboardingSo5LeaderboardPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updatePartnerOffersAgreementPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateSectionNotificationPreferencesPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateSo5LineupSettingsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateSo5UserGroupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateSportProfilePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateSquadPrivacyPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateSubscriptionPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateTaskConfigPreferencesPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateTaskPreparedLineupsCarryOverPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateUserEmailPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateUserProfilePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateUserSettingsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  upsertStepLineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  upsertTaskAppearancesPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  upsertTaskLineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  upsertTaskPreparedLineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  upsertWatchlistPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  validateApplePayMerchantSessionPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  validateFiatWalletPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  verifyInGameCurrencyPackMobilePurchasePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  verifyMobilePurchasePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  verifyPhoneNumberPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  visitCampaignPagePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
};
